const o = {
  o_burnLootbox:
    "function o_burnLootbox(address account, uint256 qty, uint256 boxtype)",
  accounOwns:
    "function accounOwns(address account, uint256 boxtype) view returns (uint256)",
  openLootbox: "function openLootbox(uint256 qty, uint256 boxtype)",
};

export default o;
